import React from "react"
import Seo from "../components/seo"
import { EventsMeta } from "../data/metaData"
import { Link } from "gatsby"
import { Container, Row, Col } from "react-bootstrap"
import Layout from "../components/layout/layout"
import { StaticImage } from "gatsby-plugin-image"
import LazyLoad from "react-lazy-load"

export const Head = () => (
  <Seo
    title={EventsMeta.metaTitle}
    description={EventsMeta.metaDescription}
    ogImage={EventsMeta.ogImage}
    twitterImage={EventsMeta.twitterImage}
  />
)

const Events = () => {

  const SeamlessSouthAfrica = '../../content/blog/digipay-guru-highlights-seamless-africa-2023/digipay-guru-at-seamless-north-africa-2023-feature-digipay-guru.webp';
  const Qatar = '../../content/blog/digipay-guru-event-highlights-mena-fintech-festival-2024/digipay-guru-event-highlights-mena-fintech-festival-2024-feature.png';
  const India = '../../content/blog/digipay-guru-convergence-india-2025-recap/digipay-guru-convergence-india-2025-recap-feature.png';
  const SeamlessNorthAfrica = '../../content/blog/digipay-guru-at-seamless-north-africa-2023/digipay-guru-at-seamless-north-africa-2023-feature.png';
  const London =
    "../../content/blog/digipay-guru-at-fintech-week-london-2023/digipay-guru-at-fintech-week-london-2023.png"
  const WFIS =
    "../../content/blog/digipay-guru-at-wfis-kenya-2023/digipay-guru-at-wfis-kenya-2023.png"
  const SeamlessAfrica =
    "../images/event-seamless-africa-22-thumb.png"
  const FintechThumg = "../images/event-fintech-thumb.png"

  const EventsSeamlessMiddle = "../images/events-seamless-middle.png"
  const EventsGitexGlobal = "../images/events-gitex-global.png"
  const EventsSeamless = "../images/events-seamless.png"
  const EventsMoney20 = "../images/events-money20.png"
  const EventsEpaySummit = "../images/events-epay-summit.png"
  const EventsSeamlessIndonesia =
    "../images/events-seamless-indonesia.png"
  const EventsFinnovex = "../images/events-finnovex.jpg"
  const EventsSingapore = "../images/events-singapore.jpg"
  const EventsFintech = "../images/events-fintech.jpg"
  const EventsUaeIsrael = "../images/events-uae-israel.jpg"
  const EventsAbuDhabi = "../images/events-abu-dhabi.jpg"
  const EventsSeamlessPayments =
    "../images/events-seamless-payments.jpg"
  const EventsAfricom = "../images/events-africom.jpg"


  const eventsList = [
    {
      topTitle: "2025",
      eventsBox: [
        {
          url: "/blog/digipay-guru-convergence-india-2025-recap",
          keyname: "India",
          date: "19 Mar 2025 – 21 Mar 2025",
          title: "Convergence India Expo 2025",
          badgeText1: "India",
          badgeText3: "In person",
        },
      ],
    },



    {
      topTitle: "2024",
      eventsBox: [
        {
          url: "/blog/digipay-guru-event-highlights-mena-fintech-festival-2024",
          keyname: "Qatar",
          date: "03 Dec 2024 – 05 Dec 2024",
          title: "MENA Event Qatar 2024",
          badgeText1: "Qatar",
          badgeText3: "In person",
        },
      ],
    },
    {
      topTitle: "2023",
      pastEvents: "Past Events",
      eventsBox: [
        {
          url: "/blog/digipay-guru-highlights-seamless-africa-2023",
          keyname: "SeamlessSouthAfrica",
          date: "September 19th - 20th, 2023",
          title: "Seamless South Africa 2023",
          badgeText1: "South Africa",
          badgeText3: "In person",
        },
        {
          url: "/blog/digipay-guru-at-seamless-north-africa-2023",
          keyname: "SeamlessNorthAfrica",
          date: "July 17th - 18th, 2023",
          title: "Seamless North Africa 2023",
          badgeText1: "North Africa",
          badgeText3: "In person",
        },
        {
          url: "/blog/digipay-guru-at-fintech-week-london-2023",
          keyname: "London",
          date: "June 19th - 23rd, 2023",
          title: "Fintech Week London 2023",
          badgeText1: "London",
          badgeText3: "In person",
        },
        {
          url: "/blog/digipay-guru-at-wfis-kenya-2023",
          keyname: "WFIS",
          date: "May 24th - 25th, 2023",
          title: "World Financial Innovations Series 2023",
          badgeText1: "Nairobi",
          badgeText3: "In person",
        }
      ],
    },
    {
      topTitle: "2022",
      eventsBox: [
        {
          url: "/blog/digipay-guru-at-seamless-africa-2022",
          keyname: "SeamlessAfrica",
          date: "October 4th - 5th, 2022",
          title: "Seamless Africa 2022",
          badgeText1: "Nairobi",
          badgeText3: "In person",
        },
        {
          keyname: "FintechThumg",
          date: "July 20 - July 22, 2022",
          title: "Fintech Festival India",
          badgeText1: "New Delhi",
          badgeText3: "In person",
        },
        {
          url: "/blog/seamless-middle-east-2022",
          keyname: "EventsSeamlessMiddle",
          date: "May 31 - June 1, 2022",
          title: "Seamless Middle East 2022",
          badgeText1: "Middle East",
          badgeText3: "In person",
        },
      ],
    },
    {
      topTitle: "2021",
      eventsBox: [
        {
          url: "/blog/digipay-guru-at-fintech-surge-gitex-global-week",
          keyname: "EventsGitexGlobal",
          date: "October 17th-20th, 2021",
          title: "GITEX Week | Fintech Surge",
          badgeText1: "Middle East",
          badgeText3: "In person",
        },
        {
          url: "/blog/digipay-guru-attended-seamless-middle-east-2021",
          keyname: "EventsSeamless",
          date: "Sep 29th-30th, 2021",
          title: "Seamless Middle East 2021",
          badgeText1: "Dubai",
          badgeText2: "Virtual",
          badgeText3: "In person",
        },
        {
          keyname: "EventsMoney20",
          date: "April 19th-23th, 2021",
          title: "Money 20/20",
          badgeText1: "USA",
          badgeText2: "Virtual",
        },
        {
          keyname: "EventsEpaySummit",
          date: "April 15th, 2021",
          title: "Epay Summit Europe",
          badgeText1: "Europe",
          badgeText2: "Virtual",
        },
        {
          keyname: "EventsSeamlessIndonesia",
          date: "April 7th-8th, 2021",
          title: "Seamless Indonesia 2021",
          badgeText1: "Virtual",
          badgeText2: "In person",
        },
        {
          keyname: "EventsFinnovex",
          date: "Feb 9th-10th, 2021",
          title: "Finnovex Digipay Event",
          badgeText1: "East Africa",
          badgeText2: "Virtual",
        },
      ],
    },

    {
      topTitle: "2020",
      eventsBox: [
        {
          keyname: "EventsSingapore",
          date: "Dec 7 - Dec 11, 2020",
          title: "Singapore FinTech Festival",
          badgeText1: "Singapore",
          badgeText3: "Virtual",
        },
        {
          keyname: "EventsFintech",
          date: "Nov 30 - Dec 04, 2020",
          title: "FinTech Connect",
          badgeText1: "London",
          badgeText2: "Virtual",
        },
        {
          keyname: "EventsUaeIsrael",
          date: "Nov 29th - Dec 4th, 2020",
          title: "UAE-Israel Fintech",
          badgeText1: "UAE",
          badgeText2: "Virtual",
        },
        {
          keyname: "EventsAbuDhabi",
          date: "Nov 25th-26th, 2020",
          title: "Abu Dhabi Fintech",
          badgeText1: "Abu Dhabi",
          badgeText2: "Virtual",
        },
        {
          keyname: "EventsSeamlessPayments",
          date: "Nov 16th-17th, 2020",
          title: "Seamless Middle east Event",
          badgeText1: "UAE",
          badgeText2: "Virtual",
        },
        {
          keyname: "EventsAfricom",
          date: "Nov 9th-12th, 2020",
          title: "AfriCom Event",
          badgeText1: "Africa",
          badgeText2: "Virtual",
        },
      ],
    },

  ]
  const getBadgeColor = (text) => {
    if (text === "In person") {
      return "bg-primary text-white";
    } else {
      return "bg-warning text-dark";
    }
  };

  return (
    <>
      <Layout>
        <section
          className="section banner-background d-md-flex align-items-center">
          <Container className="py-5 mt-lg-5">
            <div className="banner-content text-center mt-lg-4">
              <h1 className="title mb-0">DigiPay.Guru at Fintech Events</h1>
            </div>
          </Container>
        </section>

        <section className="section">
          <Container className="py-5">
            <div className="nav-tabs-link mb-5 pb-3">
              <ul className="list-unstyled d-flex align-items-center mb-0 mt-n20">
                <li>
                  <Link to="/blog">Blogs</Link>
                </li>
                <li>
                  <Link to="/product">Product</Link>
                </li>
                <li>
                  <Link to="/case-studies">Case Studies</Link>
                </li>
                <li>
                  <Link to="/whitepapers">Whitepapers</Link>
                </li>
                <li>
                  <Link to="/webinars">Webinars</Link>
                </li>
                <li className="active">
                  <Link to="/events">Events</Link>
                </li>
              </ul>
            </div>

            {eventsList?.map((item, index) => (
              <div className="mb-5" key={index}>
                <h2 className="mb-4">{item.topTitle}</h2>
                <h4 className="mb-4 mt-50">{item.pastEvents}</h4>
                <Row xs={1} lg={3} className="g-4">
                  {item.eventsBox?.map((item, index) => (
                    <Col key={index}>
                      {
                        item.url ?
                          <Link to={item.url} className='card blog-list-card'>
                            <div className="blog-image">
                              {
                                item.keyname === "India" ?
                                  <LazyLoad offsetVertical={1000}>
                                    <StaticImage loading="lazy" src={India} width={416} height={250} alt="seamless-africa-22-upcomming-thumb" />
                                  </LazyLoad> : null
                              }
                              {
                                item.keyname === "Qatar" ?
                                  <LazyLoad offsetVertical={1000}>
                                    <StaticImage loading="lazy" src={Qatar} width={416} height={250} alt="seamless-africa-22-upcomming-thumb" />
                                  </LazyLoad> : null
                              }
                              {
                                item.keyname === "SeamlessSouthAfrica" ?
                                  <LazyLoad offsetVertical={1000}>
                                    <StaticImage loading="lazy" src={SeamlessSouthAfrica} width={416} height={250} alt="seamless-africa-22-upcomming-thumb" />
                                  </LazyLoad> : null
                              }
                              {
                                item.keyname === "SeamlessNorthAfrica" ?
                                  <LazyLoad offsetVertical={1000}>
                                    <StaticImage loading="lazy" src={SeamlessNorthAfrica} width={416} height={250} alt="seamless-africa-22-upcomming-thumb" />
                                  </LazyLoad> : null
                              }
                              {
                                item.keyname === "London" ?
                                  <LazyLoad offsetVertical={1000}>
                                    <StaticImage loading="lazy" src={London} width={416} height={261} alt="seamless-africa-22-upcomming-thumb" />
                                  </LazyLoad> : null
                              }
                              {
                                item.keyname === "WFIS" ?
                                  <LazyLoad offsetVertical={1000}>
                                    <StaticImage loading="lazy" src={WFIS} width={416} height={261} alt="seamless-africa-22-upcomming-thumb" />
                                  </LazyLoad> : null
                              }
                              {
                                item.keyname === "SeamlessAfrica" ?
                                  <LazyLoad offsetVertical={1000}>
                                    <StaticImage loading="lazy" src={SeamlessAfrica} width={493} height={331} alt="seamless-africa-22-upcomming-thumb" />
                                  </LazyLoad> : null
                              }
                              {
                                item.keyname === "FintechThumg" ?
                                  <LazyLoad offsetVertical={1000}>
                                    <StaticImage loading="lazy" src={FintechThumg} width={493} height={331} alt="fintech thumg" />
                                  </LazyLoad> : null
                              }
                              {
                                item.keyname === "EventsSeamlessMiddle" ?
                                  <LazyLoad offsetVertical={1000}>
                                    <StaticImage loading="lazy" src={EventsSeamlessMiddle} width={493} height={331} alt="Events Gitex Global" />
                                  </LazyLoad> : null
                              }
                              {
                                item.keyname === "EventsGitexGlobal" ?
                                  <LazyLoad offsetVertical={1000}>
                                    <StaticImage loading="lazy" src={EventsGitexGlobal} width={493} height={331} alt="Events Gitex Global" />
                                  </LazyLoad> : null
                              }
                              {
                                item.keyname === "EventsSeamless" ?
                                  <LazyLoad offsetVertical={1000}>
                                    <StaticImage loading="lazy" src={EventsSeamless} width={493} height={331} alt="Events Seamless" />
                                  </LazyLoad> : null
                              }
                              {
                                item.keyname === "EventsMoney20" ?
                                  <LazyLoad offsetVertical={1000}>
                                    <StaticImage loading="lazy" src={EventsMoney20} width={493} height={331} alt="Events Money 20/20" />
                                  </LazyLoad> : null
                              }
                              {
                                item.keyname === "EventsEpaySummit" ?
                                  <LazyLoad offsetVertical={1000}>
                                    <StaticImage loading="lazy" src={EventsEpaySummit} width={493} height={331} alt="Events Epay Summit" />
                                  </LazyLoad> : null
                              }
                              {
                                item.keyname === "EventsSeamlessIndonesia" ?
                                  <LazyLoad offsetVertical={1000}>
                                    <StaticImage loading="lazy" src={EventsSeamlessIndonesia} width={493} height={331} alt="Events Seamless Indonesia" />
                                  </LazyLoad> : null
                              }
                              {
                                item.keyname === "EventsFinnovex" ?
                                  <LazyLoad offsetVertical={1000}>
                                    <StaticImage loading="lazy" src={EventsFinnovex} width={493} height={331} alt="Events Finnovex" />
                                  </LazyLoad> : null
                              }
                              {
                                item.keyname === "EventsSingapore" ?
                                  <LazyLoad offsetVertical={1000}>
                                    <StaticImage loading="lazy" src={EventsSingapore} width={493} height={331} alt="Events Singapore" />
                                  </LazyLoad> : null
                              }
                              {
                                item.keyname === "EventsFintech" ?
                                  <LazyLoad offsetVertical={1000}>
                                    <StaticImage loading="lazy" src={EventsFintech} width={493} height={331} alt="Events Fintech" />
                                  </LazyLoad> : null
                              }
                              {
                                item.keyname === "EventsUaeIsrael" ?
                                  <LazyLoad offsetVertical={1000}>
                                    <StaticImage loading="lazy" src={EventsUaeIsrael} width={493} height={331} alt="Events Uae Israel" />
                                  </LazyLoad> : null
                              }
                              {
                                item.keyname === "EventsAbuDhabi" ?
                                  <LazyLoad offsetVertical={1000}>
                                    <StaticImage loading="lazy" src={EventsAbuDhabi} width={493} height={331} alt="Events AbuDhabi" />
                                  </LazyLoad> : null
                              }
                              {
                                item.keyname === "EventsSeamlessPayments" ?
                                  <LazyLoad offsetVertical={1000}>
                                    <StaticImage loading="lazy" src={EventsSeamlessPayments} width={493} height={331} alt="Events Seamless Payments" />
                                  </LazyLoad> : null
                              }
                              {
                                item.keyname === "EventsAfricom" ?
                                  <LazyLoad offsetVertical={1000}>
                                    <StaticImage loading="lazy" src={EventsAfricom} width={493} height={331} alt="Events Africom" />
                                  </LazyLoad> : null
                              }

                            </div>
                            <div className="blog-list-content p-4 pt-5">
                              <div className="event-dat-time">{item.date}</div>
                              <h2 className="entry-title h3 mb-lg-3">{item.title}</h2>
                              <div>
                                <span className={`badge me-2 ${getBadgeColor(item.badgeText1)}`}>{item.badgeText1}</span>
                                <span className={`badge me-2 ${getBadgeColor(item.badgeText2)}`}>{item.badgeText2}</span>
                                <span className={`badge me-2 ${getBadgeColor(item.badgeText3)}`}>{item.badgeText3}</span>
                              </div>
                            </div>
                          </Link> :
                          <div className='card blog-list-card'>
                            <div className="blog-image">
                              {
                                item.keyname === "India" ?
                                  <LazyLoad offsetVertical={1000}>
                                    <StaticImage loading="lazy" src={India} width={416} height={250} alt="seamless-africa-22-upcomming-thumb" />
                                  </LazyLoad> : null
                              }
                              {
                                item.keyname === "Qatar" ?
                                  <LazyLoad offsetVertical={1000}>
                                    <StaticImage loading="lazy" src={Qatar} width={416} height={250} alt="seamless-africa-22-upcomming-thumb" />
                                  </LazyLoad> : null
                              }
                              {
                                item.keyname === "SeamlessSouthAfrica" ?
                                  <LazyLoad offsetVertical={1000}>
                                    <StaticImage loading="lazy" src={SeamlessSouthAfrica} width={416} height={250} alt="seamless-africa-22-upcomming-thumb" />
                                  </LazyLoad> : null
                              }
                              {
                                item.keyname === "SeamlessNorthAfrica" ?
                                  <LazyLoad offsetVertical={1000}>
                                    <StaticImage loading="lazy" src={SeamlessNorthAfrica} width={416} height={250} alt="seamless-africa-22-upcomming-thumb" />
                                  </LazyLoad> : null
                              }
                              {
                                item.keyname === "London" ?
                                  <LazyLoad offsetVertical={1000}>
                                    <StaticImage loading="lazy" src={London} width={416} height={261} alt="seamless-africa-22-upcomming-thumb" />
                                  </LazyLoad> : null
                              }
                              {
                                item.keyname === "WFIS" ?
                                  <LazyLoad offsetVertical={1000}>
                                    <StaticImage loading="lazy" src={WFIS} width={416} height={261} alt="seamless-africa-22-upcomming-thumb" />
                                  </LazyLoad> : null
                              }
                              {
                                item.keyname === "SeamlessAfrica" ?
                                  <LazyLoad offsetVertical={1000}>
                                    <StaticImage loading="lazy" src={SeamlessAfrica} width={493} height={331} alt="seamless-africa-22-upcomming-thumb" />
                                  </LazyLoad> : null
                              }
                              {
                                item.keyname === "FintechThumg" ?
                                  <LazyLoad offsetVertical={1000}>
                                    <StaticImage loading="lazy" src={FintechThumg} width={493} height={331} alt="fintech thumg" />
                                  </LazyLoad> : null
                              }
                              {
                                item.keyname === "EventsSeamlessMiddle" ?
                                  <LazyLoad offsetVertical={1000}>
                                    <StaticImage loading="lazy" src={EventsSeamlessMiddle} width={493} height={331} alt="Events Gitex Global" />
                                  </LazyLoad> : null
                              }
                              {
                                item.keyname === "EventsGitexGlobal" ?
                                  <LazyLoad offsetVertical={1000}>
                                    <StaticImage loading="lazy" src={EventsGitexGlobal} width={493} height={331} alt="Events Gitex Global" />
                                  </LazyLoad> : null
                              }
                              {
                                item.keyname === "EventsSeamless" ?
                                  <LazyLoad offsetVertical={1000}>
                                    <StaticImage loading="lazy" src={EventsSeamless} width={493} height={331} alt="Events Seamless" />
                                  </LazyLoad> : null
                              }
                              {
                                item.keyname === "EventsMoney20" ?
                                  <LazyLoad offsetVertical={1000}>
                                    <StaticImage loading="lazy" src={EventsMoney20} width={493} height={331} alt="Events Money 20/20" />
                                  </LazyLoad> : null
                              }
                              {
                                item.keyname === "EventsEpaySummit" ?
                                  <LazyLoad offsetVertical={1000}>
                                    <StaticImage loading="lazy" src={EventsEpaySummit} width={493} height={331} alt="Events Epay Summit" />
                                  </LazyLoad> : null
                              }
                              {
                                item.keyname === "EventsSeamlessIndonesia" ?
                                  <LazyLoad offsetVertical={1000}>
                                    <StaticImage loading="lazy" src={EventsSeamlessIndonesia} width={493} height={331} alt="Events Seamless Indonesia" />
                                  </LazyLoad> : null
                              }
                              {
                                item.keyname === "EventsFinnovex" ?
                                  <LazyLoad offsetVertical={1000}>
                                    <StaticImage loading="lazy" src={EventsFinnovex} width={493} height={331} alt="Events Finnovex" />
                                  </LazyLoad> : null
                              }
                              {
                                item.keyname === "EventsSingapore" ?
                                  <LazyLoad offsetVertical={1000}>
                                    <StaticImage loading="lazy" src={EventsSingapore} width={493} height={331} alt="Events Singapore" />
                                  </LazyLoad> : null
                              }
                              {
                                item.keyname === "EventsFintech" ?
                                  <LazyLoad offsetVertical={1000}>
                                    <StaticImage loading="lazy" src={EventsFintech} width={493} height={331} alt="Events Fintech" />
                                  </LazyLoad> : null
                              }
                              {
                                item.keyname === "EventsUaeIsrael" ?
                                  <LazyLoad offsetVertical={1000}>
                                    <StaticImage loading="lazy" src={EventsUaeIsrael} width={493} height={331} alt="Events Uae Israel" />
                                  </LazyLoad> : null
                              }
                              {
                                item.keyname === "EventsAbuDhabi" ?
                                  <LazyLoad offsetVertical={1000}>
                                    <StaticImage loading="lazy" src={EventsAbuDhabi} width={493} height={331} alt="Events AbuDhabi" />
                                  </LazyLoad> : null
                              }
                              {
                                item.keyname === "EventsSeamlessPayments" ?
                                  <LazyLoad offsetVertical={1000}>
                                    <StaticImage loading="lazy" src={EventsSeamlessPayments} width={493} height={331} alt="Events Seamless Payments" />
                                  </LazyLoad> : null
                              }
                              {
                                item.keyname === "EventsAfricom" ?
                                  <LazyLoad offsetVertical={1000}>
                                    <StaticImage loading="lazy" src={EventsAfricom} width={493} height={331} alt="Events Africom" />
                                  </LazyLoad> : null
                              }

                            </div>
                            <div className="blog-list-content p-4 pt-5">
                              <div className="event-dat-time">{item.date}</div>
                              <h2 className="entry-title h3 mb-lg-3">{item.title}</h2>
                              <div>
                                <span className={`badge me-2 ${getBadgeColor(item.badgeText1)}`}>{item.badgeText1}</span>
                                <span className={`badge me-2 ${getBadgeColor(item.badgeText2)}`}>{item.badgeText2}</span>
                                <span className={`badge me-2 ${getBadgeColor(item.badgeText3)}`}>{item.badgeText3}</span>
                              </div>
                            </div>
                          </div>
                      }
                    </Col>
                  ))}
                </Row>
              </div>
            ))}
          </Container >
        </section >
      </Layout >
    </>
  )
}

export default Events
